// Helper function to determine model group from model data
export function getModelGroupFromModel(model: any): string {
  if (!model || !model.name) return 'dragon-proste' // fallback
  
  const modelName = model.name.toLowerCase()
  
  // Check model name patterns to determine group
  if (modelName.includes('dragon')) {
    // Check for AKU models first
    if (model.type?.includes('aku') || modelName.includes('aku')) {
      if (model.glassType === 'narozna') {
        return 'dragon-narozne-aku'
      } else if (model.glassType === 'vis-a-vis') {
        return 'dragon-vis-a-vis-aku'
      } else {
        return 'dragon-proste-aku'
      }
    }
    // Non-AKU dragon models
    if (modelName.includes('portal')) {
      return 'dragon-portal'
    }
    if (modelName.includes('2c')) {
      return 'dragon-trojstronne'
    }
    if (model.glassType === 'narozna') {
      return 'dragon-narozne'
    }
    if (model.glassType === 'vis-a-vis') {
      return 'dragon-vis-a-vis'
    }
    if (model.glassType === 'polokragla') {
      return 'dragon-polokragle'
    }
    // Default dragon group
    return 'dragon-proste'
  }
  
  if (modelName.includes('nemo')) {
    if (model.glassType === 'narozna') {
      return 'nemo-narozne'
    }
    if (model.glassType === 'vis-a-vis') {
      return 'nemo-vis-a-vis'
    }
    return 'nemo-proste'
  }
  
  // Fallback
  return 'dragon-proste'
}

// Alternative: determine group by checking which group contains the model
export function getModelGroupFromModelsData(modelName: string): string {
  // This would require importing modelsData and checking each group
  // For now, use the pattern-based approach above
  return getModelGroupFromModel({ name: modelName })
}